// extracted by mini-css-extract-plugin
export default {"banner5":"banner5_banner5__TxYvP","img":"banner5_img__Cql32","icon":"banner5_icon__DDzPl","block":"banner5_block__J4dtw"};